import { ShopDraft, ShopScope, shopScopeKey } from './shop.types';

export const emptyShopDraft = (): ShopDraft => ({ items: [], spotId: null, costCenterId: null, basketId: null, checkoutPending: false });
const storageKey = (scope: ShopScope) => `platform-shop:v1:${shopScopeKey(scope)}`;

export function readShopDraft(scope: ShopScope): ShopDraft {
    try {
        const draft = JSON.parse(sessionStorage.getItem(storageKey(scope)) ?? 'null');
        if (
            !draft ||
            !Array.isArray(draft.items) ||
            !(draft.spotId === null || typeof draft.spotId === 'string') ||
            !(draft.costCenterId === undefined || draft.costCenterId === null || typeof draft.costCenterId === 'string') ||
            !(draft.basketId === null || typeof draft.basketId === 'string') ||
            typeof draft.checkoutPending !== 'boolean' ||
            (draft.checkoutPending && !draft.basketId) ||
            !draft.items.every(
                (item: ShopDraft['items'][number]) =>
                    item &&
                    Number.isSafeInteger(item.quantity) &&
                    item.quantity > 0 &&
                    typeof item.product?.id === 'string' &&
                    typeof item.product.name === 'string' &&
                    Array.isArray(item.product.productAttributes) &&
                    (item.product.attributeValues === undefined ||
                        (Array.isArray(item.product.attributeValues) && item.product.attributeValues.every((value) => typeof value === 'string')))
            ) ||
            new Set(draft.items.map((item: ShopDraft['items'][number]) => item.product.id)).size !== draft.items.length
        ) {
            return emptyShopDraft();
        }
        return { ...draft, costCenterId: draft.costCenterId ?? null };
    } catch {
        return emptyShopDraft();
    }
}

export function writeShopDraft(scope: ShopScope, draft: ShopDraft): boolean {
    try {
        sessionStorage.setItem(storageKey(scope), JSON.stringify(draft));
        return true;
    } catch {
        return false;
    }
}
